import React, { FC, useEffect } from "react";
import { validateMenuStep } from "./validate";
import { menuRoute } from "./route";
import { Step, validateFromTo } from "../stepsStore";
import Packages from "./PackagesSupplements";
import Supplements from "./SupplementGroupsList";
import { mainStep } from "../Main";

export const menuStep: Step = {
  order: 1,
  tKey: "menu",
  validate: validateMenuStep,
  route: menuRoute,
};

const MenuStep: FC = () => {
  useEffect(() => {
    validateFromTo(mainStep.order, menuStep.order, true, false);
  }, []);

  return (
    <>
      <Packages />

      <Supplements />
    </>
  );
};

export default MenuStep;
